import type {SelectableObject} from "./selectableObjects";
import {MathUtils} from "./mathUtils";
import globalsObject from "./globalsObject";
import {arrayElementByKeyValue} from "../global/arrayHelper";

export class owayoUtils {
    public static funktionalitaetIsBlacklisted(name) {
        if(typeof (globalsObject.infoFromGetParameters) === "undefined") {
            return false;
        }
        const blacklistItem = arrayElementByKeyValue(globalsObject.infoFromGetParameters.funktionalitaeten, "Funktionalitaet", name);
        return (blacklistItem !== null && blacklistItem.blacklisted === true);
    }

    public static funktionalitaetIsWhiteListed(name) {
        if(typeof (globalsObject.infoFromGetParameters) === "undefined") {
            return false;
        }
        const whiteListItem = arrayElementByKeyValue(globalsObject.infoFromGetParameters.funktionalitaeten, "Funktionalitaet", name);
        return (whiteListItem !== null && whiteListItem.blacklisted === false);
    }

    public static getCleanPartName(partName) {
        let result;

        result = partName.replace(/ /g, '');
        result = result.replace(/ü/g, 'ue');
        result = result.replace(/Ü/g, 'Ue');
        result = result.replace(/ä/g, 'ae');
        result = result.replace(/Ä/g, 'Ae');
        result = result.replace(/ö/g, 'oe');
        result = result.replace(/Ö/g, 'OE');
        result = result.replace(/ß/g, 'ss');

        result = result.replace(/[^A-Za-z0-9_\-. ]/g, "_");

        return result;
    }

    public static createAngleArray(numberOfAnglesToCreate) {
        const angles:number[] = [];
        const angleDelta = 360  /numberOfAnglesToCreate;
        for (let i = 0; i < numberOfAnglesToCreate; i++) {
            angles.push(i * angleDelta);
        }
        return angles;
    }

    public static removeClonesFromArray(selObArray:SelectableObject[], masters:SelectableObject[] = []) {
        function removeSelObFromArrayByIdArray(selObArray:SelectableObject[], idsToRemove) {
            return selObArray.filter(so=>idsToRemove.indexOf(so.id) === -1);
        }

        if(selObArray.length === 0) {
            return masters;
        }
        const newmaster = selObArray[0] as SelectableObject;
        const withoutClones = removeSelObFromArrayByIdArray(owayoUtils.removeFirstElementDoNotChangeInitialArray(selObArray), newmaster.cloneIds);
        return owayoUtils.removeClonesFromArray(withoutClones, masters.concat([newmaster]));
    }

    public static removeFirstElementDoNotChangeInitialArray(arr) {
        return arr.filter((v,i)=>i!==0);
    }


    public static calculate3DcoordinateOfUVIntersectionPoint(PointA_UV, PointB_UV, PointC_UV, PointD_UV, PointA_vec3, PointB_vec3, PointC_vec3) {
        const result = {x: 0, y: 0, z: 0};


        // Wir haben ein Dreieck A,B,C und einen Punkt D der irgendwo darin liegt.
        // Als erstes ziehen wir eine Linie CD und schauen wo diese die Linie AB schneidet.
        // Diesen Punkt nennen wir nun in den Kommentaren Xd
        const SchneidePunktAB = MathUtils.checkLineIntersection(PointA_UV, PointB_UV, PointC_UV, PointD_UV);

        // So wir müssen nun 2 relative Strecken ausrechen.
        // 1) AXd zu AB
        // 2) CD  zu CXd
        //
        // Durch diese Verhältnisse können wir im 3D-Dreieck das ganze rekonstruieren.
        //
        const DistAB = Math.sqrt(Math.pow((PointB_UV.x - PointA_UV.x), 2) + Math.pow((PointB_UV.y - PointA_UV.y), 2));
        const DistAXd = Math.sqrt(Math.pow((SchneidePunktAB.x - PointA_UV.x), 2) + Math.pow((SchneidePunktAB.y - PointA_UV.y), 2));
        const PropAXdzuAB = (DistAXd / DistAB);

        const DistCD = Math.sqrt(Math.pow((PointD_UV.x - PointC_UV.x), 2) + Math.pow((PointD_UV.y - PointC_UV.y), 2));
        const DistCXd = Math.sqrt(Math.pow((SchneidePunktAB.x - PointC_UV.x), 2) + Math.pow((SchneidePunktAB.y - PointC_UV.y), 2));
        const PropCDzuCXd = (DistCD / DistCXd);

        // So als erstes Rechnen wir uns den X, Y und Z Punkt auf der 3D AB Strecke aus.
        const PointXd_vec3 = {
            x: (PointA_vec3.x + ( PointB_vec3.x - PointA_vec3.x ) * PropAXdzuAB ),
            y: (PointA_vec3.y + ( PointB_vec3.y - PointA_vec3.y ) * PropAXdzuAB ),
            z: (PointA_vec3.z + ( PointB_vec3.z - PointA_vec3.z ) * PropAXdzuAB )
        };

        // Jetzt gehen wir noch Propertional von C zu Xd und dan nhaben wir bereits unser Ergebnis
        result.x = (PointC_vec3.x + ( PointXd_vec3.x - PointC_vec3.x ) * PropCDzuCXd);
        result.y = (PointC_vec3.y + ( PointXd_vec3.y - PointC_vec3.y ) * PropCDzuCXd);
        result.z = (PointC_vec3.z + ( PointXd_vec3.z - PointC_vec3.z ) * PropCDzuCXd);

        return result;
    }

    public static getCookie
}
